
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {
  LayoutDashboard, 
  Users, 
  FileText, 
  Settings, 
  MessageSquare, 
  CreditCard,
  Building, 
  BarChart2, 
  Share,
  UserRound,
  Tag,
  Paintbrush,
  Wallet
} from 'lucide-react';

const mainMenuItems = [
  { title: "Dashboard", icon: LayoutDashboard, path: "/admin/dashboard" },
  {
    title: "CRM",
    icon: MessageSquare,
    path: "/admin/crm",
  },
  {
    title: "Referral Users",
    icon: Users,
    path: "/admin/referral-users",
  },
  {
    title: "Campaigns",
    icon: Share,
    path: "/admin/campaigns",
  },
  {
    title: "Marketing",
    icon: Paintbrush,
    path: "/admin/marketing",
  },
  {
    title: "Reports",
    icon: FileText,
    path: "/admin/reports",
  },
  {
    title: "Analytics",
    icon: BarChart2,
    path: "/admin/analytics",
  },
  {
    title: "Reward Sales",
    icon: Tag,
    path: "/admin/reward-purchase",
  },
  {
    title: "Wallet & Payments",
    icon: Wallet,
    path: "/admin/payments",
  },
];

const managementMenuItems = [
  { title: "User-Role Login Manager", icon: Users, path: "/admin/user-management" },
  {
    title: "Business Setup",
    icon: Building,
    path: "/admin/business-setup",
  },
  {
    title: "Profile",
    icon: UserRound,
    path: "/admin/profile",
  },
  {
    title: "Settings",
    icon: Settings,
    path: "/admin/settings",
  },
];

const AdminSidebarNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Sidebar className="border-r border-gray-200">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {mainMenuItems.map((item) => (
                <SidebarMenuItem key={item.path}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.path)}
                    isActive={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
                  >
                    <item.icon className="w-5 h-5" />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        
        <SidebarGroup>
          <SidebarGroupLabel>Management</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {managementMenuItems.map((item) => (
                <SidebarMenuItem key={item.path}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.path)}
                    isActive={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
                  >
                    <item.icon className="w-5 h-5" />
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
};

export default AdminSidebarNav;
